import { Menu } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    Sheet,
    SheetContent,
    SheetTrigger,
    SheetHeader,
    SheetTitle,
    SheetDescription,
    SheetClose,
} from "@/components/ui/sheet";
import Logo from "@/components/Logo";

export default function HamburgerMenu() {
    const { t } = useTranslation();
    const LINKS = [
        { label: t("nav.about"), to: "/about" },
        { label: t("nav.faq"), to: "/faq" },
        { label: t("nav.travel_blog"), to: "/blog" },
        { label: t("nav.terms"), to: "/terms" },
        { label: t("nav.privacy"), to: "/privacy" },
        { label: t("nav.contact"), to: "/contact" },
    ];
    return (
        <Sheet>
            <SheetTrigger asChild>
                <button
                    type="button"
                    aria-label={t("common.open_menu")}
                    data-testid="hamburger-button"
                    className="flex h-9 w-9 items-center justify-center rounded-full text-[#0A0A0A] transition hover:bg-[#F5F5F5]"
                >
                    <Menu size={18} strokeWidth={1.75} />
                </button>
            </SheetTrigger>
            <SheetContent
                side="left"
                className="w-72 border-r border-[#E5E5E5] bg-white text-[#0A0A0A]"
                data-testid="hamburger-sheet"
            >
                <SheetHeader>
                    <SheetTitle asChild>
                        <Logo size="md" />
                    </SheetTitle>
                    <SheetDescription className="sr-only">
                        Piqpath navigation menu
                    </SheetDescription>
                </SheetHeader>
                <nav className="mt-8 flex flex-col gap-1">
                    {LINKS.map((l) => (
                        <SheetClose asChild key={l.to}>
                            <Link
                                to={l.to}
                                data-testid={`menu-link-${l.to.replace("/", "")}`}
                                className="rounded-lg px-3 py-2.5 text-[14px] font-medium text-[#0A0A0A] transition hover:bg-[#F5F5F5]"
                            >
                                {l.label}
                            </Link>
                        </SheetClose>
                    ))}
                </nav>
                <div className="mt-6 border-t border-[#E5E5E5] pt-5 flex flex-wrap items-center gap-3">
                    <a
                        href="https://play.google.com/store/apps/details?id=com.piqpath.app"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="menu-playstore-link"
                        aria-label={t("menu.get_app")}
                        className="inline-block transition hover:opacity-80"
                    >
                        <img
                            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                            alt={t("menu.get_app")}
                            width={135}
                            height={52}
                            loading="lazy"
                            className="h-[52px] w-[135px] select-none"
                        />
                    </a>
                    <a
                        href="https://apps.apple.com/us/app/piqpath/id6772143338"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="menu-appstore-link"
                        aria-label={t("menu.get_app_ios", "Download Piqpath on the App Store")}
                        className="inline-block transition hover:opacity-80"
                    >
                        <img
                            src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83"
                            alt={t("menu.get_app_ios", "Download on the App Store")}
                            width={156}
                            height={52}
                            loading="lazy"
                            className="h-[52px] w-[156px] select-none"
                        />
                    </a>
                </div>
                <div className="mt-10 border-t border-[#E5E5E5] pt-4 text-[11px] text-[#A3A3A3]">
                    <div>Piqpath · {t("common.footer_tagline")}</div>
                </div>
            </SheetContent>
        </Sheet>
    );
}
